import React, { useEffect, useState, useRef } from "react";
import "./styles.scss";
import logo from "../../images/bitcoin-live/logo.png";
import lock from "../../images/bitcoin-live/lock.png";
import introVideoIcon from "../../images/bitcoin-live/Intro_Vid_Icon.png";
import TwitterIcon from "../../images/bitcoin-live/TwitterIcon.png";
import Carousel from "../../components/common/Carousel";
import { analysts } from "./analystsJson";
import Layer16 from "../../images/bitcoin-live/Layer16.png";
import Layer15 from "../../images/bitcoin-live/Layer15.png";
import Layer14 from "../../images/bitcoin-live/Layer14.png";
import Dice from "../../images/bitcoin-live/Dice.png";
import Layer5 from "../../images/bitcoin-live/Layer5.png";
import Layer3 from "../../images/bitcoin-live/Layer3.png";
import Layer6 from "../../images/bitcoin-live/Layer6.png";
import Layer7 from "../../images/bitcoin-live/Layer7.png";
import Layer8 from "../../images/bitcoin-live/Layer8.png";
import Layer17 from "../../images/bitcoin-live/Layer17.png";
import Phone from "../../images/bitcoin-live/Phone.png";
import traderImg from "../../images/bitcoin-live/TraderPhoto.png";
import bob_avatar from "../../images/bitcoin-live/bob_avatar.jpg";
import { Modal, ModalHeader, ModalBody } from "../../components/ui";
import PlansCards from "../../components/common/PlansCards";
import MainFooter from "../../components/layout/MainFooter";
import styled, { keyframes } from "styled-components";
import { testinomials } from "./testimonial";
import { Navigate } from "react-router-dom";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";

const CheckLogin = () => {
  if (localStorage.getItem("session") !== null) {
    return <Navigate to="/blogs/premium/" replace />;
  } else {
    return null;
  }
};

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    let id = setInterval(() => {
      savedCallback.current();
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
}

const LandingPage = () => {
  const Fade = styled.div`
    display: inline-block;
    visibility: ${(props) => (props.out ? "hidden" : "visible")};
    animation: ${(props) => (props.out ? fadeOut : fadeIn)} 1s linear;
    transition: visibility 1s linear;
  `;

  const fadeIn = keyframes`
  from {
    transform: scale(.25);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

  const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 0;
  }

  to {
    transform: scale(.25);
    opacity: 1;
  }
`;

  const rightArrow = {
    fontSize: "17px",
    position: "relative",
    top: "1px",
    color: "#fff",
  };
  const [modal, setModal] = useState(false);
  const [fade, setFade] = useState(testinomials[0]);
  const [url, setUrl] = useState("");
  const [count, setCount] = useState(0);

  const MINUTE_MS = 2000;

  useInterval(() => {
    if (count === testinomials.length) {
      setCount(0);
    } else {
      setFade(testinomials[count]);
      setCount(count + 1);
    }
  }, 5000);

  const galleryBreakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 850, itemsToShow: 3 },
    { width: 1150, itemsToShow: 3 },
    { width: 1450, itemsToShow: 3.1 },
    { width: 1750, itemsToShow: 4.1 },
    { width: 2000, itemsToShow: 5.1 },
  ];

  return (
    <div className="parentDiv">
      <CheckLogin />
      <div className="headerDiv">
        <img style={{ position: "absolute" }} src={logo} alt="bitcoin" />
        <label className="textStyle">
          Bitcoin
          <br /> Live
        </label>
        <div className="buttonDiv">
          <a href="/blogs/public">
            <button className="btnStyles">
              <img className="lockImg" src={lock} />
              Public Area
            </button>
          </a>
          <a href="/blogs/premium">
            <button className="btnStyles">
              <img className="lockImg" src={lock} />
              Member's Area
            </button>
          </a>
        </div>
      </div>
      <div className="header2">
        <div style={{ width: window.screen.width < 500 ? "100%" : "50%" }}>
          <label className="text1">99% of Crypto Traders Lose Money.</label>
          <br />
          <label className="text2">Learn To Be In the 1%.</label>
          <label className="text3">
            <b style={{ color: "#fff", fontWeight: 200, opacity: 0.8 }}>
              {" "}
              Learn & profit through an exclusive educational platform run by{" "}
            </b>
            <b style={{ color: "#fff" }}>
              {" "}
              8 of the world’s leading crypto traders.
            </b>
          </label>
          <div style={{ display: window.screen.width < 500 ? "flex" : {} }}>
            <button
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
            <label
              onClick={() => {
                console.log("Why Join clicked!");
                const element = document.getElementById("scrollTo");
                console.log("Element found:", element);
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                } else {
                  console.error("scrollTo element not found!");
                }
              }}
              className="joinlink"
              style={{ cursor: "pointer" }}
            >
              Why Join Bitcoin Live?
            </label>
          </div>
        </div>
        <div className="blVideo">
          <div
            style={{
              height: window.screen.width > 500 ? "318px" : "200px",
              outline: "#fff",
              outlineStyle: "solid",
              outlineWidth: "1px",
              width: window.screen.width > 1000 ? "572px" : "100%",
            }}
            className={"wistia_embed wistia_async_fwaxun2z59"}
          ></div>
          <div className="userMsg">
            <Slider
              previousButton={false}
              nextButton={false}
              autoplay={5000}
              duration={50}
            >
              {testinomials.map((item, index) => (
                <div key={index}>
                  <div>
                    <div>
                      <label
                        style={{
                          fontWeight: 200,
                          color: "#fff",
                          opacity: 0.8,
                          paddingTop: "20px",
                        }}
                        className="text4"
                      >
                        “{item && item.content}”
                      </label>
                    </div>
                    <div className="feedbackDiv">
                      <img
                        style={{
                          borderRadius: "100px",
                          width: "50px",
                          marginRight: 10,
                          height: "50px",
                        }}
                        src={item && item.profilePic}
                      />
                      <label
                        style={{
                          marginLeft: 10,
                          marginTop: 15,
                          color: "#fff",
                          fontWeight: 400,
                        }}
                        className="text4"
                      >
                        {item && item.name}
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
          <div>
            {/* <Fade className="userMsg">
              <div>
                <div>
                  <label
                    style={{ fontWeight: 200, opacity: 0.7 }}
                    className="text4"
                  >
                    “{fade && fade.content}”
                  </label>
                </div>
                <div className="feedbackDiv">
                  <img
                    style={{
                      borderRadius: "100px",
                      width: "50px",
                      marginRight: 10,
                      height: "50px"
                    }}
                    src={fade && fade.profilePic}
                  />
                  <label
                    style={{
                      marginLeft: 10,
                      marginTop: 15,
                      color: "#fff",
                      fontWeight: 400
                    }}
                    className="text4"
                  >
                    {fade && fade.name}
                  </label>
                </div>
              </div>
            </Fade> */}
          </div>
        </div>
      </div>
      <div className="tradeDiv">
        <div className="tradeHeader">
          Meet the{" "}
          <img
            style={{ marginBottom: 10, height: 26 }}
            src={logo}
            alt="bitcoin"
          />{" "}
          bitcoin live traders{" "}
          <label style={{ opacity: "0.8", marginBottom: 0 }}>
            (& your future mentors)
          </label>
        </div>
      </div>
      <div>
        <Carousel
          transitionMs={2000}
          breakPoints={galleryBreakPoints}
          pagination={false}
        >
          {analysts.map((data) => (
            <div style={{ marginTop: 20 }}>
              <img className="profileImg" src={data.profilePic} alt="profile" />
              <div className="analystDiv">
                <div style={{ marginTop: 110 }}>
                  <label className="name">
                    {data.name}{" "}
                    <a href={data.twitterUrl} target="_blank">
                      <img src={TwitterIcon} alt="icon" />
                    </a>
                  </label>
                  <ul
                    style={{
                      lineHeight: "35px",
                      opacity: "0.7",
                      marginTop: 10,
                    }}
                  >
                    {data.content.map((item) => (
                      <li>{item}</li>
                    ))}
                  </ul>
                  {data.introVideo && (
                    <label
                      onClick={() => {
                        setModal(true);
                        setUrl(data.introVideo);
                      }}
                      className="introLabel"
                      style={{ left: data.name === "Big Cheds" ? "0px" : {} }}
                    >
                      watch {data.name}'s intro{" "}
                      <img src={introVideoIcon} alt="icon" />
                    </label>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Carousel>
        <Modal
          centered={true}
          size="md"
          isOpen={modal}
          toggle={() => {
            setModal(false);
          }}
          style={{
            minWidth: window.screen.width > 500 ? "684px" : "auto",
          }}
        >
          <ModalHeader
            toggle={() => {
              setModal(false);
            }}
            style={{ border: "none", padding: "8px 16px" }}
          ></ModalHeader>
          <ModalBody style={{ padding: "0 16px 16px 16px" }}>
            <div
              style={{ height: window.screen.width > 500 ? "400px" : "220px" }}
            >
              <div
                style={{ height: "100%" }}
                className={`wistia_embed wistia_async_${url}`}
              ></div>
            </div>
          </ModalBody>
        </Modal>
      </div>
      <div className="lightLayer">
        <div className="infoDiv">
          <label className="titleText">What is Bitcoin Live?</label>
          <p className="Pcontent">
            Bitcoin Live is an exclusive educational platform run by{" "}
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              8 veteran traders
            </b>{" "}
            who have now turned their focus to the crypto market. Its goal is to
            provide you with the knowledge, tools & techniques to
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              profitably
            </b>{" "}
            trade Bitcoin & other cryptocurrencies.
            <br />
            <br /> Over the last 5 years, Bitcoin Live members have harnessed
            the experience & trading wisdom of Peter Brandt, Bob Loukas, and the
            rest of the Bitcoin Live team to
            <b style={{ color: "black", fontWeight: "bold", opacity: 1 }}>
              {" "}
              successfully navigate multiple bull & bear markets.
            </b>
          </p>
          <div className="benefits">
            <label
              className="name"
              style={{
                marginBottom: 50,
                letterSpacing: "6px",
                fontWeight: 400,
              }}
            >
              MEMBERSHIP BENEFITS
            </label>
            <br />
            <label className="infoTitle">
              Bitcoin Live’s 8 expert trader’s will:
            </label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Layer16} />
                <br />
                <label className="infoSubTitle">
                  Answer Your Trading Questions
                </label>
              </div>
              <div className="icons">
                <img src={Layer15} /> <br />
                <label className="infoSubTitle">
                  Give You Weekly Market Updates
                </label>
              </div>
              <div className="icons">
                <img src={Layer14} /> <br />
                <label className="infoSubTitle">
                  Share Their Insight & How To Guides
                </label>
              </div>
            </div>
            <label className="infoTitle">Also, they’ll teach you:</label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Dice} />
                <br />
                <label className="infoSubTitle">
                  Effective Risk Management
                </label>
              </div>
              <div className="icons">
                <img style={{ height: "60px" }} src={Layer5} /> <br />
                <label className="infoSubTitle">
                  Pro Technical Analysis{""} {""}
                </label>
              </div>
              <div className="icons">
                <img
                  style={{ width: window.screen.width < 500 ? "75px" : {} }}
                  src={Layer3}
                />{" "}
                <br />
                <label className="infoSubTitle">
                  Bull & Bear Market Strategies
                </label>
              </div>
            </div>
            <label className="infoTitle">
              Plus, you’ll have access to their:
            </label>
            <div
              style={{
                display: "flex",
                width: "100%",
              }}
            >
              <div className="icons">
                <img src={Layer8} />
                <br />
                <label className="infoSubTitle">Trading Tips & Secrets</label>
              </div>
              <div className="icons">
                <img src={Layer6} /> <br />
                <label className="infoSubTitle">Real-Time Trade Alerts</label>
              </div>
              <div className="icons">
                <img src={Layer7} /> <br />
                <label className="infoSubTitle">Live Events & Webinars</label>
              </div>
            </div>
            <button
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
              style={{
                margin: window.screen.width > 500 ? "4% 30%" : "4% 20%",
              }}
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
          </div>
        </div>
        <div className="mobileDiv">
          <img src={Phone} />
          <label className="sampleHeader">
            GET YOUR TRADING QUESTIONS ANSWERED...
          </label>
          <div className="analystReplies">
            <img style={{ marginTop: 15 }} src={Layer17} />
            <br />
            <label className="contentSample">
              Why do you have the monthly cycle placed at 49 instead of the
              usual 47? November made a lower low too.
            </label>
            <div style={{ display: "flex", float: "right" }}>
              <div>
                <img
                  src={bob_avatar}
                  style={{
                    borderRadius: "100px",
                    width: "50px",
                    marginRight: 10,
                  }}
                />
              </div>
              <div
                style={{
                  fontFamily: "sans-serif",
                  lineHeight: "15px",
                  paddingTop: 8,
                }}
              >
                <label
                  style={{ marginBottom: 0, fontWeight: "bold", fontSize: 16 }}
                >
                  Bob Loukas
                </label>
                <br />
                <label
                  style={{ color: "#707070", fontWeight: 300, fontSize: 10 }}
                >
                  Jan-15-2023 12:32
                </label>
              </div>
            </div>
            <br />
            <div className="replyDiv">
              <label className="contentSample">
                {" "}
                Because I believe this past 60-day Cycle part of the ending move
                of a 4yr cycle that just refused to break down.
              </label>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "auto" }} className="userMsg">
        <Slider
          previousButton={false}
          nextButton={false}
          autoplay={5000}
          duration={50}
        >
          {testinomials.map((item, index) => (
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <label
                    style={{
                      padding:
                        window.screen.width > 700 ? "20px 75px" : "0px 10px",
                      fontWeight: 200,
                      opacity: 0.8,
                    }}
                    className="text4"
                  >
                    “{item && item.content}”
                  </label>
                </div>
                <div className="feedbackDiv">
                  <img
                    style={{
                      borderRadius: "100px",
                      width: "50px",
                      marginRight: 10,
                      height: "50px",
                    }}
                    src={item && item.profilePic}
                  />
                  <label
                    style={{ marginLeft: 10, marginTop: 15 }}
                    className="text4"
                  >
                    {item && item.name}
                  </label>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {/* <Fade style={{ width: "auto" }} className="userMsg">
        <div>
          <div>
            <label
              className="text4"
              style={{
                padding: window.screen.width > 1000 ? "0px 100px" : "0px 10px",
                fontWeight: 200,
                opacity: 0.7
              }}
            >
              “{fade && fade.content}”
            </label>
          </div>
          <div id="scrollTo" className="feedbackDiv">
            <img
              style={{
                borderRadius: "100px",
                width: "50px",
                marginRight: 10,
                height: "50px"
              }}
              src={fade && fade.profilePic}
            />
            <label style={{ marginLeft: 10, marginTop: 15 }} className="text4">
              {fade && fade.name}
            </label>
          </div>
        </div>
      </Fade> */}
      <div id="scrollTo" className="joinDiv">
        <label
          style={{
            color: "#252525",
            fontSize: 40,
            fontWeight: 600,
            marginBottom: 25,
          }}
        >
          Why Join Bitcoin Live?
        </label>
        <br />
        <label className="aboutcontent">
          In a crypto industry full of scams, charlatans & grifters, Bitcoin
          Live offers you a{" "}
          <b style={{ color: "#000", fontWeight: "bold" }}>
            {" "}
            trader’s safehaven
          </b>
          . A place on the Internet where you can hone your trading skill with
          the support of 8 veteran traders.
        </label>
        <div
          style={{
            width: "100%",
            display: window.screen.width > 500 ? "flex" : {},
            marginTop: 50,
          }}
        >
          <div style={{ width: window.screen.width > 500 ? "50%" : "100%" }}>
            <img
              width={window.screen.width > 500 ? "90%" : "100%"}
              height={window.screen.width > 500 ? 500 : "auto"}
              src={traderImg}
            />
          </div>
          <div
            style={{
              width: window.screen.width > 500 ? "50%" : "100%",
              marginTop: window.screen.width > 500 ? {} : 20,
            }}
          >
            <label className="subInfo">
              Learn to be a disciplined & profitable trader.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              Bitcoin Live is run by the World’s leading crypto analysts.
              They’ve put together 100s of hours of videos, articles, webinars &
              training materials to share their wisdom. All to help you become a
              long-term, profitable trader.
            </label>
            <label className="subInfo">
              Get exclusive access to expert advice.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              The analysts have over one-hundred years of cumulative trading
              experience. They’ve navigated the entire spectrum of trading
              environments, and pass on their knowledge & decision making skills
              to Bitcoin Live members.
            </label>
            <label className="subInfo">
              Benefit from ‘over-the-shoulder’ trades.
            </label>
            <label style={{ marginBottom: 30 }} className="aboutcontent">
              As a member, not only will you learn from the experts, but you’ll
              also be in the unique position to see their actual trades too!
            </label>
            <button
              id="plans"
              style={{
                margin: window.screen.width > 500 ? "4% 30%" : "0% 21%",
              }}
              onClick={() => {
                const element = document.getElementById("plans");
                if (element) {
                  element.scrollIntoView({ behavior: "smooth" });
                }
              }}
              className="joinBtn"
            >
              Join Now <i class="fa fa-caret-right" style={rightArrow}></i>
            </button>
          </div>
        </div>
      </div>
      <div style={{ margin: "3% 10% 1% 10%" }}>
        <label className="plantitle">
          You’re <b style={{ color: "#F15922" }}>1 Step Away</b> From Becoming a
          Better Crypto Trader...
        </label>
        <label
          style={{
            color: "#fff",
            fontSize: window.screen.width > 500 ? "30px" : "14px",
            margin: "4% 1%",
            textAlign: "center",
            width: "100%",
          }}
        >
          Choose from one of the following subscription plans:
        </label>
        <PlansCards noPadding />
      </div>
      <div>
        <MainFooter />
      </div>
    </div>
  );
};

export default LandingPage;
